'use es6';

import { VisualTypes } from '../../../schema/visual-records';
import { getReportVisualType } from '../../../utils/report-utils';
import { combineConstraints } from '../../validate';
import { xyLikeVisualIsDisplayable } from './common-constraints';
export const scatter = combineConstraints('scatter', [xyLikeVisualIsDisplayable], (constraint, report) => getReportVisualType(report) !== VisualTypes.SCATTER || constraint.validate(report));